export default __webpack_public_path__ + "static/media/content-library.4b3cbf01.svg";